import Link from "next/link";

import useTranslation from "next-translate/useTranslation";
import { useEffect, useState } from "react";
import { DesktopMenu } from "./desktop";
import { MobileMenu } from "./mobile";

export const Header = () => {
  const { t } = useTranslation("common");
  const [scroll, setScroll] = useState(false);
  const { lang } = useTranslation("common");

  useEffect(() => {
    const handleScroll = () => {
      setScroll(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className="fixed top-0 right-0 left-0 z-50 w-full transition-all duration-300">
      {/* Top Bar */}
      {lang !== "fr" && lang !== "en" && (
        <div
          className={classNames(
            "hidden bg-[#051124] text-white transition-all duration-300 md:block",
            scroll
              ? "h-0 overflow-hidden border-b-0 opacity-0"
              : "h-8 border-white/10 border-b opacity-100"
          )}
        >
          <div className="mx-auto flex h-full max-w-7xl items-center justify-end px-4 font-medium text-[10px] uppercase tracking-wider lg:px-8">
            <div className="flex space-x-4 opacity-70">
              <Link
                className="transition-colors hover:text-[#c1a166]"
                href="/distribution-network"
              >
                {t("menu.distributionNetwork")}
              </Link>
              <span className="text-white/20">|</span>
              <Link
                className="transition-colors hover:text-[#c1a166]"
                href="/partners"
              >
                {t("menu.partners")}
              </Link>
              <span className="text-white/20">|</span>
              <Link
                className="transition-colors hover:text-[#c1a166]"
                href="/certificates"
              >
                {t("downloads.certificates")}
              </Link>
              <span className="text-white/20">|</span>
              <Link
                className="transition-colors hover:text-[#c1a166]"
                href="/career"
              >
                {t("menu.career")}
              </Link>
              <span className="text-white/20">|</span>
              <Link
                className="transition-colors hover:text-[#c1a166]"
                href="/contact"
              >
                {t("menu.contact")}
              </Link>
            </div>
          </div>
        </div>
      )}

      {/* Main Navigation */}
      <div
        className={classNames(
          "w-full transition-all duration-300",
          scroll
            ? "bg-[#051124]/95 shadow-2xl backdrop-blur-md"
            : "bg-[#051124]"
        )}
      >
        <DesktopMenu scroll={scroll} />
        <MobileMenu />
      </div>
    </header>
  );
};

function classNames(...classes: unknown[]) {
  return classes.filter(Boolean).join(" ");
}
